import { useEffect } from 'react';
import { useAdConfig } from '../hooks/useAdConfig';

interface GoogleAdProps {
  slot: string;
  format?: 'auto' | 'fluid' | 'rectangle' | 'vertical' | 'horizontal';
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Google AdSense component
 * Publisher ID: ca-pub-1126182424925466
 */
export default function GoogleAd({ 
  slot, 
  format = 'auto', 
  style,
  className 
}: GoogleAdProps) {
  const { showAdsForCurrentUser } = useAdConfig();
  const clientId = import.meta.env.VITE_ADSENSE_CLIENT_ID || 'ca-pub-1126182424925466';

  useEffect(() => {
    if (!showAdsForCurrentUser) return;
    try {
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error('AdSense error:', err);
    }
  }, [showAdsForCurrentUser]);

  // Don't render if ads are disabled for this user
  if (!showAdsForCurrentUser) {
    return null;
  }

  return (
    <ins
      className={`adsbygoogle ${className || ''}`}
      style={{
        display: 'block',
        ...style,
      }}
      data-ad-client={clientId}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    />
  );
}

// Declare global type for adsbygoogle
declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}
